import { DetailedMealPlanItem } from '@shared/services';
import { useMutation } from '@tanstack/react-query';

const updateDetailedMealPlan = async (
  dailyRoomName: string,
  payload: DetailedMealPlanItem[],
): Promise<void> => {
  const res = await fetch(
    `/api/meal-plan/${dailyRoomName}/update-detailed-meal-plan`,
    {
      method: 'PUT',
      body: JSON.stringify(payload),
    },
  );

  if (!res.ok) {
    // soft fail.
    console.error(res);
    throw res.json();
  }

  return res.json();
};

export const useUpdateDetailedMealPlan = () =>
  useMutation({
    mutationFn: (params: {
      dailyRoomName: string;
      payload: DetailedMealPlanItem[];
    }) => updateDetailedMealPlan(params.dailyRoomName, params.payload),
  });
